/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAddress } from './PaxCheckAddress';
import {
    PaxCheckAddressFromJSON,
    PaxCheckAddressFromJSONTyped,
    PaxCheckAddressToJSON,
    PaxCheckAddressToJSONTyped,
} from './PaxCheckAddress';

/**
 * 
 * @export
 * @interface PaxCheckAddAddressRequest
 */
export interface PaxCheckAddAddressRequest {
    /**
     * 
     * @type {PaxCheckAddress}
     * @memberof PaxCheckAddAddressRequest
     */
    address: PaxCheckAddress;
}

/**
 * Check if a given object implements the PaxCheckAddAddressRequest interface.
 */
export function instanceOfPaxCheckAddAddressRequest(value: object): value is PaxCheckAddAddressRequest {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function PaxCheckAddAddressRequestFromJSON(json: any): PaxCheckAddAddressRequest {
    return PaxCheckAddAddressRequestFromJSONTyped(json, false);
}

export function PaxCheckAddAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAddAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': PaxCheckAddressFromJSON(json['address']),
    };
}

export function PaxCheckAddAddressRequestToJSON(json: any): PaxCheckAddAddressRequest {
    return PaxCheckAddAddressRequestToJSONTyped(json, false);
}

export function PaxCheckAddAddressRequestToJSONTyped(value?: PaxCheckAddAddressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': PaxCheckAddressToJSON(value['address']),
    };
}

